// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__emBU7","spinner":"Spinner_spinner__XuoMR","backdrop":"Spinner_backdrop__4H1Xh"};